module.exports = __webpack_public_path__ + "static/media/House2.aaa7f8c4.svg";